import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import $ from "jquery";
const ClassesData = [
  {
    id: "one",
    program: "English Tution - Grade 5",
    data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
    avatarData: [
      {
        studentName: "Maheen Mushtaq",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Shahreyar Ghazanfar",
        imagePath:
          "https://i.picsum.photos/id/1011/5472/3648.jpg?hmac=Koo9845x2akkVzVFX3xxAc9BCkeGYA9VRVfLE4f0Zzk",
        online: false,
      },
      {
        studentName: "Sami Ali Khan",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Saqib",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: false,
      },
      {
        studentName: "Riffat",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Malik",
        imagePath:
          "https://i.picsum.photos/id/237/200/300.jpg?hmac=TmmQSbShHz9CdQm0NkEjx1Dyh_Y984R9LpNrpvH2D_U",
        online: true,
      },
    ],
  },
  {
    id: "two",
    program: "Math Tution - Grade 5",
    data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
    avatarData: [
      {
        studentName: "Hamza",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Faheem",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Afzal",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
    ],
  },
  {
    id: "three",
    program: "Math Tution - Grade 7",
    data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
    avatarData: [
      {
        studentName: "Hamza",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Faheem",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Afzal",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
    ],
  },
  {
    id: "four",
    program: "English Tution - Grade 7",
    data: "Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.",
    avatarData: [
      {
        studentName: "Hamza",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Faheem",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
      {
        studentName: "Afzal",
        imagePath: "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
        online: true,
      },
    ],
  },
];

const RightSectionEM = () => {
  const [sysMessagesData, setsysMessagesData] = useState([]);
  // useEffect(() => {
  //   $("#accordion").click(function () {
  //     if ($("span").hasClass("fa-plus-circle")) {
  //       $("#accordion").html('<span class="fas fa-minus-circle"></span>');
  //     } else {
  //       $("#accordion").html('<span class="fas fa-plus-circle"></span>');
  //     }
  //   });
  // });
  return (
    <div
      className="border shadow-lg p-3 rounded"
      style={{ backgroundColor: "#343a40", color: "#fff", height: "100%" }}
    >
      <h5 style={{ color: "#fed700" }} className="font-italic">
        Education Mama
      </h5>

      <Link to="/dashboard">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            Demo Leads
          </label>
        </div>
      </Link>
      <Link to="/dashboards/AllStudents">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            All Students
          </label>
        </div>
      </Link>
      <Link to="/dashboards/ReferralStudents">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            Referral Students
          </label>
        </div>
      </Link>
      <Link to="/dashboards/IncompleteRegistration">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            Incomplete Registration
          </label>
        </div>
      </Link>
      <Link to="/dashboards/TeacherPipeline">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            Teacher Pipeline
          </label>
        </div>
      </Link>
      <Link to="/dashboards/LeadLogs">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            Leads Logs
          </label>
        </div>
      </Link>
      <Link to="/dashboards/TeacherRecruitment">
        <div className="mt-2 p-1 gradeNameMouse">
          <span style={{ color: "#fff" }} class="fa-solid fa-arrow-right ml-1"></span>
          <label style={{ color: "#fff", fontSize: 15 }} className="ml-2">
            Teacher Recruitment
          </label>
        </div>
      </Link>
    </div>
  );
};

export default RightSectionEM;
